module.exports = __webpack_public_path__ + "img/dashed_02.4f9f383e.png";